import { Context } from "@nuxt/types/app";

import getIsNumberOnly from "./formatting.isNumberOnly.plugin";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function (context: Context) {
  const { isNumberOnly } = getIsNumberOnly(context);

  function isPhone(event: Event, value: string, vModel: string): boolean {
    const stringTotal = `${vModel}${value}`;
    const length =
      typeof stringTotal !== "undefined"
        ? stringTotal.toString().length
        : "".length;

    // validation: number only
    if (isNumberOnly(value) && length <= 14) {
      return true;
    }

    event.preventDefault();
    return false;
  }

  return {
    isPhone,
  };
}
